export const MANUFACTURER_CLASS_PREMIUM = 'premium';
export const MANUFACTURER_CLASS_ECONOMY = 'economy';
export const MANUFACTURER_CLASS_BUDGET = 'budget';

export const TYRE_MANUFACTURER_CLASS_MAPPING = {
  [MANUFACTURER_CLASS_PREMIUM]: [
    'CONTINENTAL',
    'DUNLOP',
    'GOODYEAR',
    'MICHELIN',
    'PIRELLI',
    'BRIDGESTONE',
  ],
  [MANUFACTURER_CLASS_ECONOMY]: [
    'BF-GOODRICH',
    'FALKEN',
    'FIRESTONE',
    'FULDA',
    'GENERAL',
    'HANKOOK',
    'KLEBER',
    'KUMHO',
    'MATADOR',
    'MAXXIS',
    'NEXEN',
    'NOKIAN',
    'SEMPERIT',
    'SPORTIVA',
    'TOYO',
    'UNIROYAL',
    'VREDESTEIN',
    'YOKOHAMA',
    'BARUM',
  ],
  [MANUFACTURER_CLASS_BUDGET]: [
    'ACCELERA',
    'ACHILLES',
    'ADVANCE',
    'AEOLUS',
    'AEROTYRE',
    'AGATE',
    'ALLIANCE',
    'ALPHATREAD',
    'ALTURA',
    'ANLAS',
    'ANNAITE',
    'ANTARES',
    'ANTEO',
    'ANTYRE',
    'AOTELI',
    'APLUS',
    'APOLLO',
    'APTANY',
    'ARISUN',
    'ARIVO',
    'ARMOUR',
    'ARMSTRONG',
    'ARTRAX',
    'ASCENSO',
    'ATHOS',
    'ATLAS',
    'ATTURO',
    'AURORA',
    'AUSTONE',
    'AUTOGREEN',
    'AUTOGRIP',
    'AVON',
    'BANDAG',
    'BARKLEY',
    'BENCHMARK',
    'BERLIN TIRES',
    'BERLINER',
    'BFGOODRICH',
    'BGM',
    'BISON',
    'BK TRAILER',
    'BKT',
    'BLACKLION',
    'BLACKSTONE',
    'BOHNENKAMP',
    'BOKA AGRAR TRANS',
    'BOKA TRAILER LINE',
    'BRAWLER',
    'CACHLAND',
    'CAMAC',
    'CAMSO',
    'CARGOPOWER',
    'CARLSTAR',
    'CEAT',
    'CENTARA',
    'COMFORSER',
    'COMPASAL',
    'COMPASS',
    'CONTIRE',
    'COOPER',
    'CORDIANT',
    'CROSSLEADER',
    'CROSSWIND',
    'CST',
    'CULTOR',
    'DAVANTI',
    'DAYTON',
    'DEBICA',
    'DEESTONE',
    'DELI',
    'DELINTE',
    'DELMAX',
    'DEXTERO',
    'DMACK',
    'DOUBLE COIN',
    'DOUBLE STAR',
    'DOUBLE STAR / GERUTTI',
    'DURATOUGH',
    'DURATURN',
    'DURO',
    'DURUN',
    'DYNACARGO',
    'DYNAMO',
    'ERACLE',
    'EUROGRIP',
    'EUROSTONE',
    'EVENT',
    'EVERGREEN',
    'FARMKING',
    'FARROAD',
    'FEDERAL',
    'FESITE',
    'FINALIST',
    'FIREMAX',
    'FIRSTSTOP',
    'FORMULA',
    'FORTUNA',
    'FORTUNE',
    'FRONWAY',
    'FULLRUN',
    'FULLWAY',
    'GALAXY',
    'GISLAVED',
    'GITI',
    'GOALSTAR',
    'GOFORM',
    'GOLDEN CROWN',
    'GOLDEN TYRE',
    'GOLDLINE',
    'GOODRIDE',
    'GOODTREAD',
    'GOODTRIP',
    'GR EXCAVATOR',
    'GREENTRAC',
    'GREMAX',
    'GRENLANDER',
    'GRI',
    'GRIPMAX',
    'GROUNDSPEED',
    'GT RADIAL',
    'GTK',
    'HABILEAD',
    'HAIDA',
    'HAULER',
    'HEADWAY',
    'HEIDENAU',
    'HIFLY',
    'HILO',
    'IMPERIAL',
    'INFINITY',
    'INNOVA',
    'INSA TURBO',
    'IRC',
    'ITP-TIRES',
    'JINYU',
    'JOURNEY',
    'JOYROAD',
    'KABAT',
    'KAMA',
    'KAPSEN',
    'KELLY',
    'KENDA',
    'KETER',
    'KINFOREST',
    'KINGBOSS',
    'KINGNATE',
    'KINGS TIRE',
    'KINGSTAR',
    'KORMORAN',
    'KPATOS',
    'LANDSAIL',
    'LANDSPIDER',
    'LANVIGATOR',
    'LASSA',
    'LAUFENN',
    'LAURENT RETREAD',
    'LEAO',
    'LEONARD',
    'LEXANI',
    'LINGLONG',
    'LODER TIRE',
    'MABOR',
    'MAGIC',
    'MAGNA TYRES',
    'MARANGONI',
    'MARCHER',
    'MARSHAL',
    'MASTER-STEEL',
    'MAXAM',
    'MAXFIELD',
    'MAXIMO',
    'MAXTREK',
    'MAZZINI',
    'MEFO-SPORT',
    'MENTOR',
    'METEOR',
    'METZELER',
    'MILEKING',
    'MILESTONE',
    'MINERVA',
    'MIRAGE',
    'MITAS',
    'MOMOTIRES',
    'MRL',
    'MTP',
    'MÜLOT',
    'NANKANG',
    'NEOLIN',
    'NEXT TREAD',
    'NITTO',
    'NORDEXX',
    'NORDMAN',
    'NORTENHA',
    'NOVEX',
    'ONYX',
    'ORIUM',
    'OTR',
    'OUTRIGGER',
    'OVATION',
    'OZKA',
    'PACE',
    'PETLAS',
    'PHAROS',
    'PNEUMANT',
    'POWERTRAC',
    'PREMADA',
    'PREMIORRI',
    'PRESTIVO',
    'PRIMEX',
    'PRINX',
    'PROMETEON',
    'PROTECTOR',
    'PROTREAD',
    'PRS',
    'RADAR',
    'RAPID',
    'REBEL',
    'REDIGAL',
    'REGAL',
    'RETRO',
    'RIKEN',
    'ROADCRUZA',
    'ROADHOG',
    'ROADKING',
    'ROADMARCH',
    'ROADSTONE',
    'ROADX',
    'ROCKBLADE',
    'ROCKSTONE',
    'RODOS',
    'ROSAVA',
    'ROTALLA',
    'ROTEX',
    'ROVELO',
    'ROYAL BLACK',
    'RULA-BRW',
    'RUNWAY',
    'SAILUN',
    'SAILWIN',
    'SAMSON',
    'SAVA',
    'SCHWALBE',
    'SEBRING',
    'SECURITY',
    'SEHA',
    'SEIBERLING',
    'SENTURY',
    'SHIKARI',
    'SHINKO',
    'SILVERSTONE',
    'SIMEX',
    'SOLI-TRAC',
    'SOLIDEAL',
    'SONAR',
    'SONIX',
    'SPEEDWAYS',
    'STARCO',
    'STARFIRE',
    'STARMAXX',
    'STARPERFORMER',
    'STONE',
    'SUMITOMO',
    'SUN-F',
    'SUNFULL',
    'SUNITRAC',
    'SUNNY',
    'SUNTEK',
    'SUNWIDE',
    'SUPERIA',
    'SUPERKING',
    'SYRON',
    'T-TYRE',
    'TAIFA',
    'TAURUS',
    'TBB TIRES',
    'TECHKING',
    'TECHSHIELD',
    'TECNICA',
    'TEGRYS',
    'THREE A',
    'TIANLI',
    'TIGAR',
    'TITAN',
    'TOLEDO',
    'TOMASON',
    'TOMKET',
    'TORQUE',
    'TOURADOR',
    'TOWNHALL',
    'TRACMAX',
    'TRAYAL',
    'TRAZANO',
    'TRELLEBORG',
    'TRI-ACE',
    'TRIANGLE',
    'TRISTAR',
    'TURON',
    'TYFOON',
    'ULTRA TIRE',
    'UNIGRIP',
    'VEE-RUBBER',
    'VELOCE',
    'VIKING',
    'VITOUR',
    'VITTOS',
    'VOLTYRE',
    'WANDA',
    'WANLI',
    'WATERFALL',
    'WESTLAKE',
    'WINDFORCE',
    'WINDPOWER',
    'WINRUN',
    'YARTU',
    'YONKING',
    'ZEETEX',
    'ZETA',
    'ZMAX',
  ],
};

export const RECOMMENDED_PREMIUM_MANUFACTURER_TYRE = ['MICHELIN'];
export const RECOMMENDED_ECONOMY_MANUFACTURER_TYRE = ['KLEBER'];
export const RECOMMENDED_BUDGET_MANUFACTURER_TYRE_TRUCK = [
  'BFGOODRICH',
  'LAURENT RETREAD',
];
export const RECOMMENDED_MANUFACTURER_TYRE_TRUCK = [
  'MICHELIN',
  'BFGOODRICH',
  'LAURENT RETREAD',
];
